import { render, staticRenderFns } from "./StepListaEspecialidades.vue?vue&type=template&id=4c5dbe58"
import script from "./StepListaEspecialidades.vue?vue&type=script&lang=js"
export * from "./StepListaEspecialidades.vue?vue&type=script&lang=js"
import style0 from "./StepListaEspecialidades.vue?vue&type=style&index=0&id=4c5dbe58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports